import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const useDates = () => {
  const { t } = useTranslation();

  const formatDate = useCallback((
    date: Date,
    endDate?: Date,
    options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'numeric', year: 'numeric' },
  ) => {
    const datestring = t(`dates.${endDate ? 'range' : 'single'}`, {
      date,
      endDate,
      interpolation: { escapeValue: false },
      formatParams: {
        date: { ...options, locale: 'en-GB' },
        endDate: { ...options, locale: 'en-GB' },
      },
    });

    return datestring;
  }, [t]);

  return {
    formatDate,
  };
};

export default useDates;
